export default "__VITE_ASSET__19QF4kyt__"